
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyBvXZTpu_c0T7mWqkreHE3ECQBZibyk4UI",
  authDomain: "ceylon-wayfinder.firebaseapp.com",
  projectId: "ceylon-wayfinder",
  storageBucket: "ceylon-wayfinder.firebasestorage.app",
  messagingSenderId: "1083673926355",
  appId: "1:1083673926355:web:8877eeebb2f834d0b31226"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export